import React from 'react';
import { getCountryByDialCode } from 'services/ServiceCOUNTRYS';
import { getCountryFlagUrl } from 'services/ServiceCOUNTRYS';
import { formatPhoneNumber } from 'utils/fuctions/internationalPhoneFormatter';

function PhoneCell({ phone, ddi }) {
  if (!phone || !ddi) return null;
  const country = getCountryByDialCode(ddi);

  return (
    <>
      <img
        src={getCountryFlagUrl(country?.code)}
        alt={country?.name}
        style={{
          width: '20px',
          height: '15px',
          marginRight: '6px'
        }}
      />
      {formatPhoneNumber(ddi, phone)}
    </>
  );
}

export { PhoneCell };
